import {
	IconButton,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Tooltip,
	Typography,
} from "@mui/material";
import React from "react";
import FormatHelper from "../helper/FormatHelper";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import GroupsIcon from "@mui/icons-material/Groups";

function TableComponent({
	type,
	data,
	header,
	allStudents,
	setFlag,
	setClassStudents,
	setModalOpen,
	setConfirmModal,
}) {
	return (
		<TableContainer component={Paper}>
			<Table
				sx={{ "& .MuiTableCell-root": { padding: "10px", fontSize: "14px" } }}>
				<TableHead sx={{ backgroundColor: "#E6E1F4" }}>
					<TableRow>
						<TableCell
							sx={{
								fontWeight: "bold",
							}}>
							ردیف
						</TableCell>
						{header.map((item, index) => (
							<TableCell
								key={index}
								sx={{
									fontWeight: "bold",
								}}>
								{item.label}
							</TableCell>
						))}
						<TableCell
							sx={{
								fontWeight: "bold",
							}}>
							عملیات
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{data.length < 1 ? (
						<Typography p={2}>هیچ موردی یافت نشد.</Typography>
					) : (
						data.map((item, index) => {
							return (
								<TableRow key={index}>
									<TableCell>{FormatHelper.toPersianString(`${index + 1}`)}</TableCell>
									{header.map((header, colIndex) => (
										<TableCell key={colIndex}>
											{header.render
												? header.render(item[header.key], item)
												: item[header.key]}
										</TableCell>
									))}
									<TableCell className="d-flex">
										{type === "class" && (
											<>
												<Tooltip title="مدیریت اعضا" arrow>
													<IconButton
														onClick={() => {
															setClassStudents(
																allStudents.filter(s => s.class?.classId === item?.classId)
															);
															setFlag({
																status: 1,
																title: `لیست اعضا کلاس ${item.className}`,
																data: item,
															});
														}}>
														<GroupsIcon sx={{ fontSize: 24 }} color="primary" />
													</IconButton>
												</Tooltip>
												<Tooltip title="ویرایش کلاس" arrow>
													<IconButton
														onClick={() => {
															setModalOpen({ open: true, type: "edit", data: item });
														}}>
														<EditIcon sx={{ fontSize: 24 }} color="secondary" />
													</IconButton>
												</Tooltip>
											</>
										)}
										<Tooltip
											title={type === "class" ? "حذف کلاس" : "حذف دانش آموز"}
											arrow>
											<IconButton
												onClick={() => {
													setConfirmModal({
														confirmOpen: true,
														id: type === "class" ? item?.classId : item?.class?.classMemberId,
														studentId: type === "class" ? null : item?.id,
														type: type,
													});
												}}>
												<DeleteIcon sx={{ fontSize: 24 }} color="error" />
											</IconButton>
										</Tooltip>
									</TableCell>
								</TableRow>
							);
						})
					)}
				</TableBody>
			</Table>
		</TableContainer>
	);
}

export default TableComponent;
